import { FormControl as MuiFormControl, FormHelperText, styled as MUIstyled } from '@mui/material'
import styled from 'styled-components'

export const FormControl = styled(MuiFormControl)`
  .MuiOutlinedInput-root.MuiInputBase-formControl {
    &:hover {
      fieldset {
        border: 1px solid ${({ theme }) => theme.customerColor};
      }
    }

    &:active {
      fieldset {
        border: 1px solid ${({ theme }) => theme.customerColor};
      }
    }
  }

  .MuiOutlinedInput-root.MuiInputBase-formControl.disabled-input {
    input {
      cursor: default;
      opacity: 1;
      color: rgba(0, 0, 0, 0.38);
      font-size: 1rem;
      line-height: 1.5rem;
      padding: 1rem;
    }

    fieldset {
      border: 1px solid rgba(0, 0, 0, 0.26);
    }
  }
`

export const Label = MUIstyled(FormHelperText)`
  color: #4E5256;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
`
